import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  connect
} from 'react-redux';
import { getError, getState } from 'reducers/meta';
import {
  getTotal,
  getCustomers,
  getCustomer,
  getPolicies,
  getClaims,
  actions
} from 'reducers/coverage';
import QueryForm from './QueryForm';
import QueryResults from './QueryResults';
import QueryShow from './QueryShow';

const {
  queryRequest: queryCoverage,
  showRequest: showCoverage
} = actions;

class QueryContainer extends Component {
  static propTypes = {
    queryCoverage: PropTypes.func.isRequired,
    queryResults: PropTypes.shape({
      total: PropTypes.number.isRequired,
      customers: PropTypes.arrayOf(
        PropTypes.object
      ).isRequired,
      state: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string
      ]).isRequired,
      error: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string
      ]).isRequired,
    }),
    showCoverage: PropTypes.func.isRequired,
    showResults: PropTypes.shape({
      customer: PropTypes.object.isRequired,
      policies: PropTypes.objectOf(PropTypes.object).isRequired,
      claims: PropTypes.objectOf(PropTypes.object).isRequired,
      state: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string
      ]).isRequired,
      error: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string
      ]).isRequired,
    }),
  };

  state = {
    query: {},
  };

  onQuery = query => {
    this.setState({
      query: {
        ...query,
        state: 'request'
      }
    }, () => {
      this.props.queryCoverage(query);
    })
  };

  onShow = id => {
    this.props.showCoverage(this.state.query, id);
  };

  renderQueryResults = () => {
    const {
      total,
      customers,
      state,
      error
    } = this.props.query;

    return (
      <QueryResults
        state={state}
        total={total}
        customers={customers}
        error={error}
        onSelect={this.onShow}
      />
    )
  };

  renderShowResult = () => {
    const {
      customer,
      policies,
      claims,
      state,
      error
    } = this.props.show;

    return (
      <QueryShow
        state={state}
        customer={customer}
        policies={policies}
        claims={claims}
        error={error}
      />
    )
  };

  render() {
    return (
      <Fragment>
        <QueryForm
          onSubmit={this.onQuery}
        />
        {this.renderQueryResults()}
        {this.renderShowResult()}
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  query: {
    total: getTotal(state.coverage),
    customers: getCustomers(state.coverage),
    state: getState(state.meta, 'coverage_query'),
    error: getError(state.meta, 'coverage_query')
  },
  show: {
    customer: getCustomer(state.coverage),
    policies: getPolicies(state.coverage),
    claims: getClaims(state.coverage),
    state: getState(state.meta, 'coverage_show'),
    error: getError(state.meta, 'coverage_show')
  }
});

const mapDispatchToProps = {
  queryCoverage,
  showCoverage,
};

export default connect(mapStateToProps, mapDispatchToProps)(QueryContainer);



// WEBPACK FOOTER //
// ./src/components/Query/QueryContainer.js